import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-814e4944"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fas fa-user-tie me-2" }, null, -1))
const _hoisted_2 = { class: "row px-3" }
const _hoisted_3 = { class: "col-4 d-flex justify-content-center align-items-center" }
const _hoisted_4 = { class: "photo text-center" }
const _hoisted_5 = ["src"]
const _hoisted_6 = { class: "col-8" }
const _hoisted_7 = { class: "px-3" }
const _hoisted_8 = { class: "mb-3" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "name",
  class: "form-label text-muted"
}, " ชื่อ ร.นรม./รมต.นร.: ", -1))
const _hoisted_10 = ["value"]
const _hoisted_11 = { class: "mb-3" }
const _hoisted_12 = {
  key: 0,
  class: "invalid-feedback d-inline",
  role: "alert"
}
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", {
  value: null,
  disabled: "",
  selected: "",
  hidden: ""
}, "กรุณาเลือกตำแหน่ง", -1))
const _hoisted_14 = ["value"]
const _hoisted_15 = { class: "mb-3" }
const _hoisted_16 = {
  key: 0,
  class: "invalid-feedback d-inline",
  role: "alert"
}
const _hoisted_17 = ["disabled"]
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fas fa-trash-alt" }, null, -1))
const _hoisted_19 = ["disabled"]
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fas fa-ban" }, null, -1))
const _hoisted_21 = ["disabled"]
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fas fa-save" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Multiselect = _resolveComponent("Multiselect")!
  const _component_BaseModalComponent = _resolveComponent("BaseModalComponent")!

  return (_openBlock(), _createBlock(_component_BaseModalComponent, {
    ref: "cabinetMinisterForm",
    backdrop: "static",
    overflow: true,
    onHide: _ctx.clearForm
  }, {
    title: _withCtx(() => [
      _hoisted_1,
      _createTextVNode(_toDisplayString(_ctx.title), 1)
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("img", {
              class: "photo-image",
              src: _ctx.minister?.photo,
              width: "60",
              height: "70",
              alt: "preview"
            }, null, 8, _hoisted_5)
          ])
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _hoisted_9,
              _createElementVNode("input", {
                type: "text",
                value: _ctx.minister?.fullName,
                class: "form-control",
                readonly: true,
                "aria-label": "name",
                autocomplete: "off"
              }, null, 8, _hoisted_10)
            ]),
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("label", {
                for: "ministerPositionId",
                class: _normalizeClass(["form-label text-muted", {'is-invalid': _ctx.submited && _ctx.errors.ministerPositionId}])
              }, " ตำแหน่ง: ", 2),
              (_ctx.submited && _ctx.errors.ministerPositionId)
                ? (_openBlock(), _createElementBlock("div", _hoisted_12, " * กรุณาเลือกตำแหน่ง "))
                : _createCommentVNode("", true),
              _withDirectives(_createElementVNode("select", {
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.formData.ministerPositionId) = $event)),
                class: _normalizeClass(["form-select", {'is-invalid': _ctx.submited && _ctx.errors.ministerPositionId}]),
                onChange: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.unsubmit && _ctx.unsubmit(...args))),
                "aria-label": "position"
              }, [
                _hoisted_13,
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.ministerPositions, (position, index) => {
                  return (_openBlock(), _createElementBlock("option", {
                    key: index,
                    value: position.id
                  }, _toDisplayString(position.name), 9, _hoisted_14))
                }), 128))
              ], 34), [
                [_vModelSelect, _ctx.formData.ministerPositionId]
              ])
            ]),
            _createElementVNode("div", _hoisted_15, [
              _createElementVNode("label", {
                for: "regions",
                class: _normalizeClass(["form-label text-muted", {'is-invalid': _ctx.submited && _ctx.errors.regions}])
              }, " เขตตรวจราชการ: ", 2),
              (_ctx.submited && _ctx.errors.regions)
                ? (_openBlock(), _createElementBlock("div", _hoisted_16, " * กรุณาเลือกเขตตรวจราชการ "))
                : _createCommentVNode("", true),
              _createVNode(_component_Multiselect, {
                modelValue: _ctx.formData.regions,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.formData.regions) = $event)),
                mode: "tags",
                placeholder: "กรุณาเลือกเขตตรวจราชการ",
                searchable: true,
                options: _ctx.regionOptions
              }, null, 8, ["modelValue", "options"])
            ])
          ])
        ])
      ])
    ]),
    footer: _withCtx(() => [
      (_ctx.isEditMode)
        ? (_openBlock(), _createElementBlock("button", {
            key: 0,
            type: "button",
            class: "btn btn-danger me-auto",
            disabled: _ctx.isLoading,
            onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.deleteClick && _ctx.deleteClick(...args)))
          }, [
            _hoisted_18,
            _createTextVNode(" ลบ ")
          ], 8, _hoisted_17))
        : _createCommentVNode("", true),
      _createElementVNode("button", {
        type: "button",
        class: "btn btn-secondary",
        disabled: _ctx.isLoading,
        onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.hide && _ctx.hide(...args)))
      }, [
        _hoisted_20,
        _createTextVNode(" ปิด ")
      ], 8, _hoisted_19),
      _createElementVNode("button", {
        type: "button",
        class: "btn btn-primary",
        disabled: _ctx.isLoading,
        onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.submitClick && _ctx.submitClick(...args)))
      }, [
        _hoisted_22,
        _createTextVNode(" บันทึก ")
      ], 8, _hoisted_21)
    ]),
    _: 1
  }, 8, ["onHide"]))
}